'use client';

import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { UserCredential, signInWithEmailAndPassword } from 'firebase/auth';
import Image from 'next/image';
import { ReactElement, useCallback, useState } from 'react';
import { useLoadingCallback } from 'react-loading-hook';
import minimalLogo from '../../../assets/minimal-logo.png';
import { CenterPage } from '../../../components/CenterPage';
import { getFirebaseAuth, loginWithGoogle } from '../../../libs/auth/firebase';
import { useRedirectAfterLogin } from '../../../libs/auth/useRedirectAfterLogin';
import { loginWithCredential } from '../../api';
import { GoogleIcon } from './_GoogleIcon/GoogleIcon';
import { PasswordForm, PasswordFormValue } from './_PasswordForm';
export default function SignIn() {
  const $ = _c(20);
  const [hasLogged, setHasLogged] = useState(false);
  const redirectAfterLogin = useRedirectAfterLogin();
  let t0;
  if ($[0] !== redirectAfterLogin) {
    t0 = async function (credential) {
      await loginWithCredential(credential);
      redirectAfterLogin();
    };
    $[0] = redirectAfterLogin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleLogin = t0;
  let t1;
  if ($[2] !== handleLogin) {
    t1 = async t2 => {
      const {
        email,
        password
      } = t2;
      setHasLogged(false);
      const auth = getFirebaseAuth();
      await handleLogin(await signInWithEmailAndPassword(auth, email, password));
      setHasLogged(true);
    };
    $[2] = handleLogin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const [handleLoginWithEmailAndPassword, isEmailLoading, emailPasswordError] = useLoadingCallback(t1);
  let t2;
  if ($[4] !== handleLogin) {
    t2 = async () => {
      setHasLogged(false);
      const auth_0 = getFirebaseAuth();
      await handleLogin(await loginWithGoogle(auth_0));
      setHasLogged(true);
    };
    $[4] = handleLogin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [handleLoginWithGoogle, isGoogleLoading, googleError] = useLoadingCallback(t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src={minimalLogo} alt="Jesus Film Project" width={70} height={70} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hasLogged) {
    t4 = hasLogged && <Box height={300} display="flex" alignItems="center" justifyContent="center"><CircularProgress /></Box>;
    $[7] = hasLogged;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== emailPasswordError || $[10] !== googleError || $[11] !== handleLoginWithEmailAndPassword || $[12] !== handleLoginWithGoogle || $[13] !== hasLogged || $[14] !== isEmailLoading || $[15] !== isGoogleLoading) {
    t5 = !hasLogged && <PasswordForm loading={isEmailLoading} onSubmit={handleLoginWithEmailAndPassword} error={emailPasswordError ?? googleError}><Button variant="outlined" loading={isGoogleLoading} disabled={isGoogleLoading} onClick={handleLoginWithGoogle} startIcon={<GoogleIcon />} fullWidth={true}>Sign in with Google</Button></PasswordForm>;
    $[9] = emailPasswordError;
    $[10] = googleError;
    $[11] = handleLoginWithEmailAndPassword;
    $[12] = handleLoginWithGoogle;
    $[13] = hasLogged;
    $[14] = isEmailLoading;
    $[15] = isGoogleLoading;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <CenterPage>{t3}{t4}{t5}</CenterPage>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}